import { NoGroupFundLabel } from '@foresightdata/metrics-calculator';
import { IFundDataModel } from '../../../../data-models/fund.data-model';
import { IMetricsDataModel } from '../../../../data-models/metrics.data-model';

export const FUND_FAMILY_COL_ID = 'FundFamily';
export const FUND_FAMILY_FIELD = 'fundFamily';

// The Fund Family column itself comes from the api's /column list (colId 'FundFamily', field 'fundFamily',
// served only while legalStructureEnabled is on); the grid reads the label runMetricsCalculations stamps.
export function fundFamilyLabelForRow(
  row: Pick<IMetricsDataModel, 'transactions'> & { familyFundId?: number | null },
  fundsById: Map<number, IFundDataModel>,
  shadowFundIdByFamily: Map<number, number>
): string {
  if (row.familyFundId !== undefined) {
    return row.familyFundId == null
      ? NoGroupFundLabel
      : (fundsById.get(row.familyFundId)?.name ?? NoGroupFundLabel);
  }
  const labels = new Set<string>();
  for (const t of row.transactions ?? []) {
    const familyId = t.fundId != null ? fundsById.get(t.fundId)?.familyId : t.familyId;
    if (familyId == null) {
      labels.add(NoGroupFundLabel);
      continue;
    }
    const shadowFundId = shadowFundIdByFamily.get(familyId);
    labels.add((shadowFundId != null ? fundsById.get(shadowFundId)?.name : undefined) ?? NoGroupFundLabel);
  }
  return labels.size === 0 ? NoGroupFundLabel : [...labels].join(', ');
}
